export default "__VITE_ASSET__CIimHfZE__"